enum ThreeYCAction {
  EDIT_3YC_TERMS = 'Edit 3YC terms',
  ENROLL_3YC = 'Enroll for 3YC',
  ACCEPT_3YC_COMMITMENT = 'Accept/Reject 3YC Commitment',
  ACCEPT_3YC_UPDATE = 'Accept/Reject new 3YC Quantities',
  ACCEPT_3YC_RECOMMITMENT = 'Accept/Reject 3YC Recommitment'
}

export default ThreeYCAction;